import KeyAccount from './KeyAccount'
import Employee from './Employee'
export class SaveKeyAccountRequest {
    KeyAccount: KeyAccount;
    SavedByEmployee: Employee;
}

export default SaveKeyAccountRequest;